<app-customers-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-customers-filters>

<mat-card class="add-button-container" *ngIf="!(customers | async)">
  <h4>Nessun cliente trovato</h4>
  <button class="add-button" mat-raised-button (click)="addCustomer()">
    Aggiungi
  </button>
</mat-card>

<div class="table-container">
  <table mat-table matSort [dataSource]="customers" multiTemplateDataRows matSortDisableClear matSortActive="name"
    matSortDirection="asc">

    <ng-container matColumnDef="surname">
      <th mat-header-cell *matHeaderCellDef> Cognome </th>
      <td mat-cell *matCellDef="let element"> {{ element.surname }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Telefono </th>
      <td mat-cell *matCellDef="let element"> {{ element.phone }} </td>
    </ng-container>

    <ng-container matColumnDef="fidelity_card_points">
      <th mat-header-cell *matHeaderCellDef> Punti fidelity </th>
      <td mat-cell *matCellDef="let element"> {{ element.fidelityCardPoints || 0 }} </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Attivo </th>
      <td mat-cell *matCellDef="let element"> {{ element?.active === true ? 'Si' : 'No' }} </td>
    </ng-container>

    <!-- <ng-container matColumnDef="tenant">
      <th mat-header-cell *matHeaderCellDef> Punto Vendita </th>
      <td mat-cell *matCellDef="let element">
        {{ getTenantsList(element) }}
      </td>
    </ng-container> -->

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="add-icon-container">
        <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo cliente" (click)="$event.stopPropagation(); addCustomer()"
          color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row" class="modify-icon-container">
        <ng-container>
          <button mat-icon-button (click)="$event.stopPropagation(); editCustomer(row)">
            <mat-icon matTooltip="Modifica">create</mat-icon>
          </button>
        </ng-container>

        <button *ngIf="canSelect" mat-raised-button (click)="selectUser(row)">
          Seleziona
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editCustomer(row)"></tr>
  </table>

  <!-- <mat-paginator [length]="dataSource.total | async" [pageSize]="pageSizeOptions[0]" [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons ></mat-paginator>
    <mat-progress-bar *ngIf="dataSource.loading | async" mode="query"></mat-progress-bar> -->
  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSizeOptions[0]" [length]="total | async">
  </mat-paginator>
</div>
